module.exports = __webpack_public_path__ + "img/bg_popupTitle1.b6221932.png";